import {combineReducers} from "redux"
import {reducer as toastr} from "react-redux-toastr"

import BlockNavigationReducer from "@irati/utils/history/utils/store/reducer"
import InsightsReducer from "@irati-web/insights/src/store/reducers/insights"
import TeamsReducer from "@irati/identity/store/reducers/Teams"
import SearchReducer from "@irati-web/search/src/store/reducers/Search"
import LangReducer from "@irati/utils/lang/store/reducer"
import WalletReducer from "@irati/wallet/store/reducers/Wallet"
import WalletScheduledTransferReducer from "@irati/wallet/store/reducers/ScheduledTransfer"
import WalletStatementItemReducer from "@irati/wallet/store/reducers/StatementItem"
import AuthenticationReducer from "@irati/auth/store/reducers/AuthenticationReducer"
import GeoLocationReducer from "@irati/geolocation/src/store/reducers/GeoLocation"
import Survey from "@irati-web/survey/src/store/reducers/survey"
import ProductReducer from "@irati/deals/store/reducers/Product"
import NewDealReducer from "@irati/deals/store/reducers/NewDealReducer"
import RewardAdminReducer from "@irati/reward/store/reducers/RewardAdminReducer"

import MqReducer from "./mq"
import PopUpReducer from "./PopUpReducer"

const reducers = {
  auth: AuthenticationReducer,
  newDeal: NewDealReducer,
  survey: Survey,
  insights: InsightsReducer,
  mq: MqReducer,
  teams: TeamsReducer,
  popup: PopUpReducer,
  search: SearchReducer,
  toastr,
  product: ProductReducer,
  blockNavigation: BlockNavigationReducer,
  lang: LangReducer,
  wallet: WalletReducer,
  walletScheduledTransfer: WalletScheduledTransferReducer,
  walletStatementItem: WalletStatementItemReducer,
  reward: RewardAdminReducer,
  geoLocation: GeoLocationReducer
}

export default combineReducers(reducers)

export {reducers}
